import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "../Navbar";
import Footer from "./Footer";

function SetPassword() {
  const [new_password, setPassword] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  // Extract `uid` and `token` from the URL
  const queryParams = new URLSearchParams(location.search);
  const uid = queryParams.get("uid");
  const token = queryParams.get("token");

  const handleSubmit = (event) => {
    event.preventDefault();

    const apiEndpoint = `${process.env.REACT_APP_API_BASE_URL}/auth/set-password/`;
    const headers = {
      "Content-Type": "application/json",
    };

    // Data to be sent in the POST request
    const data = {
      new_password,
      uid,
      token,
    };

    // console.log("Request data:", data);

    axios
      .post(apiEndpoint, data, { headers })
      .then((response) => {
        // console.log(response.data);
        navigate("/user_confirmation");
      })
      .catch((error) => {
        console.error(error);
        alert("Failed to Set Password");
      });
  };
  return (
    <>
      <Navbar />
      <div className="parent-container">
        <div className="d-flex parts">
          <div className="part1 flex-column justify-content-center align-items-center">
            <p className="wel text-white text-center">Welcome to Screenify</p>
            <h3 className="welcome text-white text-center">
              A simple and efficient way to screen resumes using AI.
            </h3>
          </div>
          <div className="part2 d-flex flex-column justify-content-center align-items-center">
            <div className="container">
              <div className="row d-flex justify-content-center align-items-center h-120">
                <div className="col-9 col-md-8 col-lg-6 col-xl-7 shadow bg-white log">
                  <h2 className="text-center">Set Password</h2>
                  <form onSubmit={handleSubmit}>
                    <div className="mb-2">
                      <label htmlFor="password" className="form-label">
                        New Password
                      </label>
                      <input
                        type="password"
                        className="form-control bg-transparent"
                        id="password"
                        pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).{8,}"
                        title="Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character, and must be at least 8 characters long."
                        value={new_password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>

                    <div className="text-center py-2">
                      <button type="submit" className="btn me-2 btn-dark">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default SetPassword;
